import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
const Disconnect = (props) => (<Svg width="36" height="36" viewBox="0 0 36 36" fill="none" {...props}>
    <Rect width="36" height="36" rx="8" fill="#E7F3FB"/>
    <Path d="M21.1111 21.8886L25 17.9997L21.1111 14.1108" stroke="#3999DE" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M25 18H15.6667" stroke="#3999DE" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M15.6667 25H12.5556C12.143 25 11.7473 24.8361 11.4556 24.5444C11.1639 24.2527 11 23.857 11 23.4444V12.5556C11 12.143 11.1639 11.7473 11.4556 11.4556C11.7473 11.1639 12.143 11 12.5556 11H15.6667" stroke="#3999DE" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default Disconnect;
